// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ExperienceYears-module__wrapper___SCezx {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  /* 見出しが.selectionWrapperの外にあるため、他ステップ(40+32)と同じ72pxで揃える */\n  padding-top: 72px;\n}\n\n.ExperienceYears-module__selectionWrapper___0dHfr {\n  display: flex;\n  flex-direction: row;\n  max-width: 400px;\n  grid-gap: 16px;\n  grid-gap: 16px;\n  gap: 16px;\n  justify-content: center;\n  padding: 32px 16px 16px 16px;\n  flex-wrap: wrap;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "ExperienceYears-module__wrapper___SCezx",
	"selectionWrapper": "ExperienceYears-module__selectionWrapper___0dHfr"
};
export default ___CSS_LOADER_EXPORT___;
